
<template>
    
        <mars-view><mars-view class="consult-form-content-img icon iconfont" :class="showFull ? 'full' : ''" @click.native.stop="chooseImg"></mars-view><mars-view v-if="uploadProcess > 0 && uploadProcess < 99">loading</mars-view></mars-view>
    
</template>

<script>
/**
 * @file upload组件
 * @author sunxiaofeng01
 *
*/
/* global getApp, getCurrentPages */
const maxSize = 10; // 最大文件大小，单位 MB
import { reqPathTo } from '../../static/utils/env.js';
import { getData } from '../../static/utils/request.js';
export default {
  name: 'upload',
  data() {
    return {
      scrollLeft: 0,
      imgList: [],
      uploadPercent: 0,
      uploadProcess: 0,
      uploadStatus: '',
      uploadTaskList: []
    };
  },
  props: {
    maxImgNum: {
      'type': Number,
      'default': 3
    },
    list: {
      'type': Array,
      default() {
        return [];
      }
    },
    showFull: {
      'type': Boolean,
      'default': false
    }
  },
  watch: {
    list(val) {
      this.imgList = val;
    }
  },
  methods: {
    upload() {
      this.getBosKey(this.imageUpload);
    },
    getBosKey(cb) {
      const url = reqPathTo('getboskey', this.ctx, '', 'law/common');
      getData({
        url: url,
        data: {
          product: 'consult'
        }
      }).then(res => {
        const {
          bucket,
          end_point,
          path_prefix,
          prefix,
          smartapp_data = {}
        } = res;
        cb && cb({
          policy: smartapp_data.policy,
          signature: smartapp_data.signature,
          ak: smartapp_data.ak,
          endPoint: end_point.indexOf(bucket) > -1 ? end_point : end_point.replace(/^(https?:\/\/)(.+)/, `$1${bucket}.$2`),
          pathPrefix: path_prefix,
          prefix
        });
      }).catch(() => {
        this.uploadFail();
      });
    },
    uploadFileToBos({
      policy,
      signature,
      ak,
      endPoint,
      pathPrefix,
      prefix
    }, file, idx, cb) {
      return new Promise((resolve, reject) => {
        if (!file.w && !file.h) {
          this.$api.getImageInfo({
            src: file.path,
            success(res) {
              file.w = res.width;
              file.h = res.height;
            }
          });
        }
        // 证明之前已经上传过了
        if (file.url) {
          cb && cb(100);
          resolve();
          return;
        }
        let picUrl = reqPathTo('upload', this.ctx, '', 'law/common');
        {
          picUrl += '&bucketName=law_smart&storeDir=identity_head_image';
          let formData = new FormData();
          formData.append('file', file);
          let that = this;
          let httpRequest = new XMLHttpRequest();
          httpRequest.open('POST', picUrl, true);
          httpRequest.onerror = function (error) {
            that.uploadFail();
            reject(error);
            that.uploadTaskList[idx] = null;
          };
          httpRequest.onload = function (e) {
            try {
              let res = JSON.parse(e.target.response);
              if (e.target.status === 200) {
                file.url = res.data.url;
                resolve({
                  data: res,
                  statusCode: 200
                });
              } else {
                that.uploadFail();
                reject({
                  data: res,
                  statusCode: 200
                });
              }
              reject({
                data: res,
                statusCode: 200
              });
              that.uploadTaskList[idx] = null;
            } catch (error) {
              that.uploadFail();
              reject(error);
              that.uploadTaskList[idx] = null;
            }
          };
          httpRequest.send(formData);
          return;
        }
        this.$api.uploadFile({
          url: picUrl,
          filePath: file.path,
          name: 'file',
          formData: {
            accessKey: ak,
            policy,
            signature,
            bucketName: 'law_smart',
            storeDir: 'identity_head_image',
            key: pathPrefix + file.path.split('/').pop()
          },
          success: res => {
            res = res || {};
            res.statusCode = 200;
            if (res.statusCode === 200) {
              file.url = res.data.data.url;
              resolve(res);
            } else {
              this.uploadFail();
              reject(res);
            }
            reject(res);
            this.uploadTaskList[idx] = null;
          },
          fail: err => {
            this.uploadFail();
            reject(err);
            this.uploadTaskList[idx] = null;
          }
        });
      });
    },
    startUpload(params, fileList, cb) {
      return Promise.all(fileList.map((v, i) => this.uploadFileToBos(params, v, i, cb)));
    },
    imageUpload(params) {
      this.uploadStatus = 'uploading';
      this.uploadProcess = 0;
      this.startUpload(params, this.imgList, this.imageUploadCb).then(() => {
        this.uploadProcess = 0;
        this.$emit('changeImage', this.imgList);
        this.uploadStatus = '';
      }).catch(() => {
        this.uploadProcess = 0;
        this.uploadStatus = 'uploadFail';
        this.uploadFail();
      });
    },
    uploadFail() {
      this.uploadStatus = '';
      this.$api.showToast({
        title: '网络出现问题，请重新上传',
        icon: 'none'
      });
      // 重置图片
      this.imgList = this.imgList.filter(item => {
        return item.url && item.w && item.h;
      });
      this.$emit('changeImage', this.imgList);
    },
    imageUploadCb(res) {
      this.uploadProcess += res;
      // 图片上传完不算完成，等后端请求成功了才算
      const tmp = this.uploadProcess / this.imgList.length * 0.99 | 0;
      this.uploadPercent = tmp > 99 ? 99 : tmp;
    },
    cancelUpload() {
      this.uploadStatus = '';
      this.uploadProcess = 0;
      this.abortUpload();
    },
    abortUpload() {
      this.uploadTaskList.forEach((val, idx) => {
        val && val.abort();
        this.uploadTaskList[idx] = undefined;
      });
    },
    getObjUrl(file) {
      let url = null;
      // 下面函数执行的效果是一样的，只是需要针对不同的浏览器执行不同的 js 函数而已
      if (window.createObjectURL !== undefined) {
        // basic
        url = window.createObjectURL(file);
      } else if (window.URL !== undefined) {
        // mozilla(firefox)
        url = window.URL.createObjectURL(file);
      } else if (window.webkitURL !== undefined) {
        // webkit or chrome
        url = window.webkitURL.createObjectURL(file);
      }
      return url;
    },
    chooseImg() {
      const {
        maxImgNum,
        imgList
      } = this;
      if (imgList.length >= maxImgNum) {
        this.$api.showToast({
          title: `最多可选择${maxImgNum}张图片`,
          icon: 'none'
        });
        return;
      }
      this.$api.chooseImage({
        count: maxImgNum - imgList.length,
        success: res => {
          this.$emit('startUpload');
          res.tempFiles = Array.from(res.tempFiles);
          if (res.tempFiles.length > maxImgNum) {
            this.$api.showToast({
              title: `最多可选择${maxImgNum}张图片`,
              icon: 'none'
            });
            res.tempFiles = res.tempFiles.splice(0, maxImgNum);
            // return;
          }

          res.tempFiles.forEach(item => {
            item.path = this.getObjUrl(item);
          });
          const tmpList = res.tempFiles.filter(v => v.size <= maxSize * 1024 * 1024);
          this.imgList = [...imgList, ...tmpList];
          try {
            this.upload();
          } catch (error) {}
          if (tmpList.length !== res.tempFiles.length) {
            this.$api.showToast({
              title: `请选择${maxSize}MB以下的文件`,
              icon: 'none'
            });
          }
          this.$mpUpdated(() => {
            this.scrollLeft = (this.scrollLeft || 2000) + 1;
          });
        }
      });
    }
  }
};
</script>

<style scoped>
.consult-form-content-img {
  display: inline-block;
  width: 24px;
  height: 20px;
  font-size: 24px;
  line-height: 20px;
  color: #222;
}
.full {
  position: absolute;
  width: 100px;
  height: 100px;
  left: 50%;
  top: 50%;
  transform: translate3d(-50%, -50%, 0);
  opacity: 0;
}

</style>
